import React from 'react';

import StudyProgramsDetails from './StudyProgramDetails';
import StudyProgramsList from './StudyProgramsList';

export default class StudyPrograms extends React.Component {
  componentWillMount() {
    this.props.loadRates();
    this.props.loadQuals();
  }

  render() {
    return (
      <div className="bibliography-container">
        <StudyProgramsList {...this.props} />
        <StudyProgramsDetails {...this.props} />
      </div>
    );
  }
}
